<template>
  <div class="Others13Charts">
    <div
      v-if="IframeSrc && IframeSrc.toLowerCase().endsWith('.mp4')"
      class="iframeTip"
      :style="{
        height: `${$w_Ratio(8 + getShowfontSizeBase(), $store)}px`,
        lineHeight: `${$w_Ratio(8 + getShowfontSizeBase(), $store)}px`,
        fontSize: `${$w_Ratio(-14 + getShowfontSizeBase(), $store)}px`,
      }"
    >
      温馨提示：延迟半小时限行管控措施，为此带来不便，敬请谅解！
    </div>

    <keepalive>
      <div class="iframeGetStyle" :class="getStyle('Style')">
        <!-- 根据文件类型显示不同的元素 -->
        <video
          v-if="IframeSrc && IframeSrc.toLowerCase().endsWith('.mp4')"
          :src="IframeSrc"
          autoplay
          loop
          muted
          playsinline
          style="width: 100%; object-fit: fill"
        >
          您的浏览器不支持HTML5视频播放
        </video>
        <iframe v-else :src="IframeSrc" id="childtIframe" scrolling="no" frameborder="0"></iframe>
      </div>
    </keepalive>
  </div>
</template>

<script>
import { request } from '../../../common/request';
export default {
  name: 'Others13Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      male: 20,
      female: 30,
      fontStyle: {},
      IframeSrc: '',
      iframeContent: '', // 存储iframe传来的文字，方便其他地方使用
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        this.IframeSrc = this.Configuration.propertyData.ExternalLinks.value;
        console.log('从Configuration获取到的IframeSrc:', this.IframeSrc); // 打印src文字
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });

    // 默认取api参数
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    this.IframeSrc = this.Configuration.propertyData.ExternalLinks.value;

    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');

    this.getApiDataResByFilterAndResponseQuery();
    // 移除原来在mounted末尾的message事件监听器

    // 监听跨域消息（核心）
    window.addEventListener('message', e => {
      // 仅验证消息来自目标iframe，不限制域名（跨域关键）
      const iframe = document.getElementById('childtIframe');
      if (e.source === iframe?.contentWindow && e.data?.content) {
        this.iframeContent = e.data.content; // 接收跨域数据
        console.log('跨域接收成功:', this.iframeContent);
      }
    });

    this.initIframeListener(); // 初始化iframe消息监听
  },

  methods: {
    initIframeListener() {
      const iframe = document.getElementById('childtIframe');
      if (!iframe) return;

      // iframe加载完成提示（可选，仅用于调试）
      iframe.onload = () => {
        console.log('iframe加载完成，等待跨域消息...');
      };

      // 监听跨域消息（核心：仅验证消息来源是目标iframe，不限制域名）
      window.addEventListener('message', e => {
        // 只处理来自当前iframe的消息（跨域场景下唯一安全校验）
        if (e.source !== iframe.contentWindow) return;

        // 适配静态数据的content字段（替换原来的text）
        if (e.data?.content) {
          this.iframeContent = e.data.content; // 接收跨域数据
          console.log('跨域接收成功:', this.iframeContent);
        }
      });
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      // this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
        this.fontStyle = fontStyle;
      }

      this.data = source;
      // 关闭加载
      this.$nextTick(() => {
        // this.loading.close();
        this.loading = false;
        // console.log('关闭加载', this.loading.close);
      });

      console.log(source, 'aaaaaa');
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);
    },

    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 加载
      // debugger
      // this.loading = null
      // this.loading = ElLoading.service({
      //   target: this.$refs.people_num,
      //   text: '加载中...',
      //   background: 'transparent',
      //   customClass: this.getStyle('Loading'),
      // });
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          // this.loading.close();
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        // this.loading.close();
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  Configuration: {
    componentTitle: '外链组件',
    componentName: 'Others13Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others13Charts.png',
    id: '',
    style: {
      width: 330,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      // 外链 地址
      ExternalLinks: {
        propertyComponentName: 'iframeHyperlinks',
        value: '',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 450,
          height: 200,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 20,
          xAxisColor: 'rgba(96, 231, 255, 1)',
          yAxisSize: 20,
          yAxisColor: 'rgba(15, 237, 146, 1)',
        },
      },
      // chartsColor: {
      //   propertyComponentName: 'ArrayColorSelector',
      //   value: {
      //     chartColor: [
      //       'rgba(223,65,56,1)',
      //       'rgba(229,115,63,1)',
      //       'rgba(240,189,108,1)',
      //       'rgba(237,214,102,1)',
      //       'rgba(77,168,222,1)',
      //       'rgba(25,168,164,1)',
      //     ],
      //     chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
      //   },
      // },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>
<style scoped lang="scss">
.Others13Charts {
  color: white;
  padding: 4px;
  z-index: 3;
  width: 100%;
  height: 100%;

  .iframeTip {
    background: #000000;
    color: #ffffff;
    position: absolute;
    top: 0;
    width: 99.6%;
    padding-left: 3%;
  }

  .iframeGetStyle {
    z-index: 3;
    width: 100%;
    height: 100%;

    iframe {
      z-index: 1;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
